/**
 * Base64 Encode Command
 * Encode text or files to Base64
 */
import { Command } from 'commander';
import { readFile } from 'fs/promises';
import { UtilsService } from '../../services/utils.service.js';

async function handleBase64Encode(
    input: string | undefined,
    options: {
        file?: string;
        urlSafe: boolean;
    }
): Promise<void> {
    const service = new UtilsService();

    try {
        let encoded: string;

        if (options.file) {
            const content = await readFile(options.file);
            encoded = service.base64Encode(content, options.urlSafe);
        } else {
            if (!input) {
                console.error('❌ Please provide input text or use --file option');
                process.exit(1);
            }
            encoded = service.base64Encode(input, options.urlSafe);
        }

        console.log('📝 Base64 Encoded:');
        console.log('────────────────────────────────────────');
        if (options.file) {
            console.log(`   File: ${options.file}`);
        }
        if (options.urlSafe) {
            console.log(`   Format: URL-safe`);
        }
        console.log();
        console.log(`   ${encoded}`);
        console.log();
    } catch (error) {
        console.error('❌ Error:', error instanceof Error ? error.message : String(error));
        process.exit(1);
    }
}

export function createBase64EncodeCommand(): Command {
    const cmd = new Command('base64-encode')
        .description('Encode text or file to Base64')
        .argument('[input]', 'Text to encode')
        .option('-f, --file <path>', 'Encode file contents')
        .option('--url-safe', 'Use URL-safe Base64 encoding')
        .addHelpText('after', `
Examples:
  $ jai1 utils base64-encode "hello world"
  $ jai1 utils base64-encode "hello world" --url-safe
  $ jai1 utils base64-encode --file ./document.txt
  $ jai1 utils base64-encode --file ./image.png
`)
        .action(async (input, options) => {
            await handleBase64Encode(input, options);
        });

    return cmd;
}
